import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IClearance } from "@/models/clearance.entity";
import clearanceService from "@/services/mrfiktiv/services/clearance.service";
import { MrfiktivClearanceControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const ClearancePageDataProvider = new (class extends AbstractPageDataProvider<
  IClearance,
  MrfiktivClearanceControllerGetParamsGen
> {
  async getPage(query: MrfiktivClearanceControllerGetParamsGen): Promise<IPageViewModel<IClearance>> {
    const res = await clearanceService.getAll(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IClearance[];

    return { meta, data };
  }
})();
